import Image, { type ImageProps } from 'next/image'
import { shouldBypassImageOptimizer } from '@/lib/strapi-image'

/**
 * `next/image` wrapper for Strapi (and other) remote URLs.
 *
 * Local Strapi (`127.0.0.1:1337`) cannot pass through the Next optimizer
 * without `images.dangerouslyAllowLocalIP` — we set `unoptimized` automatically
 * so dev + Lighthouse always get a real `<img src="…">` and LCP can register.
 */
export function StrapiImage({ src, unoptimized, ...props }: ImageProps) {
  const srcString = typeof src === 'string' ? src : ''
  const bypass =
    unoptimized === true ||
    (unoptimized !== false && shouldBypassImageOptimizer(srcString))

  return <Image src={src} unoptimized={bypass} {...props} />
}
